module.exports = __webpack_public_path__ + "static/media/galerija_2017 (1).638ba011.jpg";